import { MODELS, useModel } from "../../api";
import Button from "../../design-system/components/Button/Button.jsx";
import { Variants } from "../../design-system/components/Button/Variants.jsx";
import Dialog from "../../design-system/components/Dialog/Dialog.jsx";
import tokens from "../../design-system/tokens";
import { demoCallToAction } from "./demoCallToAction";

type DemoRestrictedDialogProps = {
  open: boolean;
  setOpen: (open: boolean) => void;
};

/**
 * Shown when a demo visitor clicks a toolbar action that needs a real
 * Lernreise behind it. The action button leaves the demo, which unmounts the
 * dialog with it.
 */
function DemoRestrictedDialog({ open, setOpen }: DemoRestrictedDialogProps) {
  const me = useModel(MODELS.ME);
  const action = demoCallToAction(me);

  return (
    <Dialog
      open={open}
      setOpen={setOpen}
      title={"In Demo nicht verfügbar!"}
      buttons={[
        <Button
          key="secondary-button"
          onClick={() => setOpen(false)}
          type="button"
          variant={Variants.SECONDARY}
        >
          Schließen
        </Button>,
        // The footer clones every entry, so a missing action is left out
        // rather than passed as null.
        ...(action
          ? [
              <Button
                key="action-button"
                to={action.to}
                variant={Variants.PRIMARY}
              >
                {action.label}
              </Button>,
            ]
          : []),
      ]}
    >
      <div>
        <p
          style={{
            marginBottom: tokens.space[8],
          }}
        >
          {action?.dialog}
        </p>
      </div>
    </Dialog>
  );
}

export default DemoRestrictedDialog;
